/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

// Separate time and area blocks

/*
* Area block
*/

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements, getAllowedOutputs } from '../block_compatibility_checks';
import { dataset, getCurrentSat, validateFrom, validateTo } from '../dataset';
import { CustomFieldDate } from '../../blocklyFieldDate';

/*
* Date selection block
*/
Blockly.Blocks['input_date_selection'] = {
    init: function () {
        let fd = dataset.setFrom(getCurrentSat(this))
        if (fd == null) { fd = '2018-01-01' }
        let td = dataset.getTo(getCurrentSat(this))
        if (td == null) { td = '2019-01-01' }

        this.appendDummyInput('inp')
            .appendField("From:    ", 'from_text')
            .appendField(new CustomFieldDate(fd,
                function (newValue) { return validateFrom(this, newValue); }, 'true'), 'fd')
            .appendField(' To:', 'to_text')
            .appendField(new CustomFieldDate(td,
                function (newValue) { return validateTo(this, newValue); }, 'true'), 'td');
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('dates'));
        this.setInputsInline(false);
        this.setPreviousStatement(true, 'dates');
        this.setNextStatement(true, getAllowedOutputs('dates'));
        this.setStyle('input');
        this.setTooltip(Blockly.Msg.DATES_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.prevp = null
        this.setOnChange(() => {
            if (this.prev_sat != getCurrentSat(this)) {
                this.updateDates_(getCurrentSat(this));
                this.prev_sat = getCurrentSat(this);
            }
            if (this.getSurroundParent() !== this.prevp && this.getSurroundParent() !== null) {
                this.removeInput('do')
                let sat = getCurrentSat(this)
                let next = 'boundaries_other'
                if (['l8', 'l7', 'l4', 'l5', 's2', 'SAR', 'PALSAR'].includes(sat)) { next = 'boundaries' }
                this.appendStatementInput("do")
                    .setCheck(getAllowedStatements(next));
                this.prevp = this.getSurroundParent()
            }
        });
    },

    updateDates_: function (sat) {
        let input = this.getInput('inp')
        input.removeField('from_text', true);
        input.removeField('fd', true);
        input.removeField('to_text', true);
        input.removeField('td', true);

        if (sat == 'PALSAR') {
            this.getInput('inp')
                .appendField("Year:  ", "from_text")
                .appendField(new Blockly.FieldDropdown([["2007", "2007"], ["2008", "2008"], ["2009", "2009"], ["2010", "2010"], ["2015", "2015"], ["2016", "2016"], ["2017", "2017"]]), 'fd')
                .appendField("  To:  ", "to_text")
                .appendField(new Blockly.FieldDropdown([["2007", "2007"], ["2008", "2008"], ["2009", "2009"], ["2010", "2010"], ["2015", "2015"], ["2016", "2016"], ["2017", "2017"]]), 'td');
            var dropd = this.getField('td');
            dropd.setValue('2008');
        } else {
            this.getInput('inp')
            let fd = dataset.setFrom(getCurrentSat(this))
            if (fd == null) { fd = '2018-01-01' }
            let td = dataset.getTo(getCurrentSat(this))
            if (td == null) { td = '2019-01-01' }
            this.getInput('inp')
                .appendField("From:    ", 'from_text')
                .appendField(new CustomFieldDate(fd,
                    function (newValue) { return validateFrom(this, newValue); }, 'true'), 'fd')
                .appendField(' To:', 'to_text')
                .appendField(new CustomFieldDate(td,
                    function (newValue) { return validateTo(this, newValue); }, 'true'), 'td');



            /*.appendField("From:    ", 'from_text')
              
                                  .appendField(new Blockly.FieldDate(dataset.getFrom(sat)), 'fd')
                                  .appendField(' To:', 'to_text')
                                  .appendField(new Blockly.FieldDate(dataset.getTo(sat)), 'td');
                                  
              // DATE CHECKS
              .appendField(new Blockly.FieldDate(dataset.getFrom(sat), function (newValue) {
                var before = new Date(newValue);
                var fromStr = dataset.getFrom(sat);
                var fromDate = new Date(fromStr);
                if (before < fromDate)
                  return fromStr;
                return newValue;
              }), 'fd')
              .appendField(' To:', 'to_text')
              .appendField(new Blockly.FieldDate(this.addOneYear(this.getFieldValue('fd')), function (newValue) {
                var before = new Date(this.sourceBlock_.getFieldValue('fd'));
                var after = new Date(newValue);
                var td = new Date(dataset.getTo(sat));
                if ((after - before > 31622400000) || (after - before <= 0) || (after > td)) {
                  
                  $( function() {
                    $("#dialog").dialog('open');
                  });
                  return this.sourceBlock_.prev_date;
                  
                }
                this.sourceBlock_.prev_date = newValue;
                return newValue;
              }), 'td');*/
        }
    },

    addOneYear: function (fd) {
        var d = new Date(fd);
        var c = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
        c = c.toISOString().split('T')[0];
        this.prev_date = c;
        return c;
    }
};